export default "__VITE_ASSET__CFhzTw$z__"